var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVegetarian({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.113 5.325c1.408 0 2.378 1.406 1.872 2.714l-2.054 5.318a.973.973 0 0 1-1.818 0L5.06 8.039c-.506-1.308.464-2.714 1.872-2.714h.5L6.21 4.112a.663.663 0 0 1 0-.942.67.67 0 0 1 .947 0l.195.195v-.37c0-.367.3-.665.669-.665.37 0 .669.298.669.665v.37l.195-.195a.67.67 0 0 1 .946 0 .663.663 0 0 1 0 .942L8.613 5.325h.5Zm-.422 5.74a.417.417 0 1 0 0-.831H7.353a.417.417 0 1 0 0 .832h1.338Zm.668-2.662a.417.417 0 1 0 0-.832H6.685a.417.417 0 1 0 0 .832h2.674ZM8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0Zm0 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Z",
    fill: "#0E111D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegetarian);
export default __webpack_public_path__ + "static/media/vegetarian.5d9020f5a3f5d4a405bb6e319bbe5330.svg";
export { ForwardRef as ReactComponent };